var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caption-s medium",class:_vm.pillClass},[(_vm.showIcon)?_c('eg-icon',{staticClass:"pill-icon",attrs:{"icon":_vm.iconName,"size":"small"}}):_vm._e(),_c('span',{staticClass:"pill-text"},[_vm._v(_vm._s(_vm.similarity)+"%")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }